export const TokenIVrService = "IVrService";
export interface IVrService {
  SaveSessionDataDialog(sessionData: string): void;
}
